import cn from "classnames";
import styles from "./loading.module.scss";

const InnerLoading = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(styles.loading, className)}
      role="status"
      aria-label="Loading..."
    >
      <div className={styles["loading-container"]}>
        <svg
          className={styles.spinner}
          viewBox="10 10 40 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="30" cy="30" r="15" />
        </svg>
      </div>
    </div>
  );
};

export default InnerLoading;
